import Contract from '../../utils/contract'

const contract = new Contract()


export default [
  {
    title: 'email',
    type: 'email',
    tag: 'input',
    fn: (value, message) => {
      contract.clear()
      contract.isEmail(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    },

    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  {
    title: 'cep',
    tag: 'InputMask',
    type: 'zipcode',
    mask: '99999 - 999',
    pattern: /^\d{5} - \d{3}$/,
    fn: (value, message) => {
      contract.clear()
      contract.isCep(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cpf',
    type: 'text',
    tag: 'InputMask',
    mask: '999.999.999-99',
    pattern: /^\d{3}\.\d{3}.\d{3}-\d{2}$/,
    fn: (value, message) => {
      contract.clear()
      contract.validateCpf(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }

  },
  {
    title: 'cnpj',
    tag: 'InputMask',
    mask: '99.999.999/9999-99',
    pattern: /^\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2}$/,
    value: /_| |-|\./g,
    fn: (value, message) => {
      contract.clear()
      contract.validateCNPJ(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }


  },
  {
    title: 'cpf-cnpj',
    tag: 'InputMask',
    mask: '999.999.999-99',
    pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
    fn: (value, message) => {
      contract.clear()
      value.replace(/\D/g, '').length <= 11
        ? contract.validateCpf(value, message)
        : contract.validateCNPJ(value, message)

      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },

  {
    title: 'cpfCnpj',
    tag: 'InputMask',
    mask: '999.999.999-99',
    pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
    fn: (value, message) => {
      contract.clear()
      value.replace(/\D/g, '').length <= 11
        ? contract.validateCpf(value, message)
        : contract.validateCNPJ(value, message)

      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'cpfCnpj',
    tag: 'InputMask',
    mask: '999.999.999-99',
    pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
    fn: (value, message) => {
      contract.clear()

      value.replace(/\D/g, '').length <= 11
        ? contract.validateCpf(value, message)
        : contract.validateCNPJ(value, message)

      return {
        hasError: !contract.isValid(),
        message: message
      }
    }

  },
  {
    title: 'phone',
    type: 'tel',
    tag: 'InputMask',
    pattern: '',
    mask: '(99) 9999-9999',
    fn: (value, message) => {
      contract.clear()
      contract.isPhone(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'phoneMobile',
    type: 'tel',
    tag: 'InputMask',
    pattern: '',
    mask: '(99) 99999-9999',
    fn: (value, message) => {
      contract.clear()
      contract.isPhone(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'phoneFixed',
    type: 'tel',
    tag: 'InputMask',
    pattern: '',
    mask: '(99) 9999-9999',
    fn: (value, message) => {
      contract.clear()
      contract.isPhone(value, message)
      return {
        hasError: !contract.isValid(),
        message: message
      }
    }
  },
  {
    title: 'text',
    type: 'text',
    tag: 'input',
    pattern: '',
  },
  {
    title: 'email',
    type: 'email',
    tag: 'input',
    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  {
    title: 'number',
    pattern: '',
    tag: 'input',
    type: 'number'
  },
  {
    title: 'password',
    type: 'password',
    tag: 'input',
    pattern: '',
    icons: ['mdn-Icon-ocultar', 'mdn-Icon-exibir']
  },
  {
    title: 'search',
    pattern: '',
    tag: 'input',
    type: 'search',
    icons: [
      {
        name: 'mdn-Icon-busca',
        ariaLabel: 'Search'
      },
      {
        name: 'mdn-Icon-fechar',
        ariaLabel: 'Search'
      }
    ]
  },
  {
    title: 'action',
    tag: 'input',
    type: 'text',
    icons: 'mdn-Icon-direita',
    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },
  {
    tag: 'textarea',
    title: 'textarea',
    tag: 'textarea',
    pattern: ''
  },
  {
    title: 'select',
    pattern: '',
    tag: 'select',
    type: 'select'
  },{
    tag: 'date',
    title: 'date',
    tag: 'date',
    pattern: ''
  },
]
